// The public site's bundle (P8.1, D29).
//
// Separate from the admin's for the same reason its stylesheet is: the staff
// console should not ship a 3D hero, and the public site should not ship Trix.
// esbuild builds every app/javascript/*.* entry, so this file is the public
// layout's one <script>.
//
// The design system's JS is vendored under app/assets/design and imported for
// its side effects, exactly as the design's own pages load it. Never edit
// those files here: change the design repo, bump the pin in
// config/design_system.yml, run bin/sync-design.

import "@hotwired/turbo-rails"
import "./turbo_confirm"
// The PUBLIC manifest, not the generated index: the generated one registered
// every controller into whichever bundle imported it, so the staff console's
// drawer, bulk uploader and live queue shipped to every visitor (P10.3).
import "./controllers/public"

// Lucide, as a prebuilt bundle that sets `window.lucide`. Icons are written in
// the markup by name (`data-lucide="calendar"`) and drawn on load. The design's
// house rule: size them with a CSS rule, never an inline style, because
// createIcons() replaces the element and silently drops inline properties.
import "../assets/design/icons.js"

// NOT `../assets/design/nav.js`. Its IIFE captures #topbar and #navtoggle once
// at load and a Turbo visit replaces both, so the menu would work on the first
// page a visitor landed on and silently stop on every page after it. The same
// behaviour, against the same classes, is public_nav_controller.js — Stimulus
// reconnects on every visit, which is exactly what D29 keeps it for.

// The decorative line layer. It reads the section geometry and draws the
// ribbons, which is why it is a script rather than a background image: the
// strokes have to know where the content ends. The bleed contract in
// graphics.css is what keeps them from being clipped dead on a container edge.
import "../assets/design/lines.js"

// Icons are drawn from the DOM on load, so a Turbo visit that swaps the body
// leaves the new page's `data-lucide` elements untouched. `createIcons` is
// idempotent — it only replaces elements that still carry the attribute.
document.addEventListener("turbo:load", () => window.lucide?.createIcons())

// TWO THINGS THE LAYOUT (P8.2) HAS TO HANDLE, written down here so they are
// not discovered by eye:
//
// 1. `lines.js` is an IIFE that scans `[data-lines]` once and exposes no
//    redraw, so after a Turbo visit the new page has no ribbons. Whatever the
//    layout does about that — a full page load for public navigation, or a
//    re-executed script tag in the body — is a decision for P8.2, not a
//    silent no-op here.
//
// 2. It resolves `./tube.js` and the stroke data from
//    `document.currentScript.src`, which a module bundle does not set: inside
//    this bundle it takes its own documented fallback and draws the section
//    ribbons FLAT, without the tube surface. That is the decorative layer
//    only. The hero, which is what the tube shading exists for, imports
//    `../assets/design/tube.js` directly in P8.5 — a real ES module with real
//    exports, which is the thing bundlers are good at.
